var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in&amp;out/color-white/crypto/eth") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "in&out/color-white/crypto/eth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5,0 C58.20975,0 75,16.79025 75,37.5 C75,58.20975 58.209,75 37.5,75 C16.791,75 0,58.21425 0,37.5 C0,16.78575 16.788,0 37.5,0",
    id: "Path",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ethereum-eth-logo",
    transform: "translate(21.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#343434",
    points: "16.9950151 0 16.6235323 1.27617467 16.6235323 38.3045296 16.9950151 38.6793593 33.9895967 28.5195009"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8C8C8C",
    points: "16.9950151 0 0 28.5195009 16.9950151 38.6793593 16.9950151 20.7068218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3C3C3B",
    points: "16.9950151 41.9335828 16.7856496 42.1917988 16.7856496 55.3818597 16.9950151 56 34 31.7789851"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8C8C8C",
    points: "16.9950151 56 16.9950151 41.9335828 0 31.7789851"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#141414",
    points: "16.9950151 38.6793593 33.9895967 28.5195009 16.9950151 20.7068218"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#393939",
    points: "0 28.5195009 16.9950151 38.6793593 16.9950151 20.7068218"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.d0ca8403d4940088948cba39a7b5c819.svg";
export { ForwardRef as ReactComponent };